import React, { useEffect, useState } from 'react'
import NavBar from '../../components/navBar/NavBar'
import './login.css'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, db } from '../../utitilties/firebase';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';

const CenterPwd = () => {

    const navigate = useNavigate()

    const { userId, email, authset } = (useLocation()).state

    const [confirmPwd, setCofirmPwd] = useState('')
    const [password, setPassword] = useState('')
    const [pwdMatch, setPwdMatch] = useState(true)

    const loginHandler = async () => {
        if (!password) {
            return alert('Enter Password')
        }
        await signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;

                navigate('/')


            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(error.message)
            });
    }

    const signupHandler = async () => {
        console.log(password, confirmPwd)
        if (!password || (password != confirmPwd)) {
            return alert('Password Doesnt Match')
        }
        await createUserWithEmailAndPassword(auth, email, password)
            .then(async (userCredential) => {
                const user = userCredential.user;

                await updateDoc(doc(db, "PhysioCenters", userId), {
                    isAuthSet: true
                }).then(() => {
                    navigate('/')
                }).catch((error) => alert('Error'))



            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(error.message)
            });
    }

    const checkIfCenterEmail = async (email) => {
        const q = query(collection(db, "PhysioCenters"), where("email", "==", email));

        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            return false
        } else {
            return true
        }

    }

    useEffect(() => {
        if (password && confirmPwd) {
            if (password == confirmPwd) {
                setPwdMatch(true)
            } else {
                setPwdMatch(false)
            }
        }
    }, [password,confirmPwd])

    return (
        <>
            <NavBar />
            <div className='login'>
                <div className='login_sub' >
                    <h1>Login</h1>


                    <input
                        type="password"
                        className="text_input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        style={{ borderColor: pwdMatch ? 'green' : 'red' }}
                    />
                    {!authset && < input
                        type="password"
                        className="text_input"
                        value={confirmPwd}
                        onChange={(e) => setCofirmPwd(e.target.value)}
                        placeholder="Confirm Password"
                        style={{ borderColor: pwdMatch ? 'green' : 'red' }}
                    />
                    }
                    <div className="btn"
                        onClick={() => { authset ? loginHandler() : signupHandler() }}
                    >
                        <p>{authset ? 'Login' : 'Signup'}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CenterPwd